/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.categories.create.email.controllers', [
  'acme.common.service.membership',
  'acme.common.service.validate',
  'acme.common.service.api',
  'acme.common.factory.notice'
])

.controller('MembershipCategoriesCreateEmailController', ['$scope', 'MembershipService', 'ApiService', 'NoticeFactory', 'ValidateService', function($scope, MembershipService, ApiService, NoticeFactory, ValidateService) {

    $scope.membershipCategoriesCreateEmail = {

      model: {},

      shortDescriptionMax: 300,
      shortDescriptionRemaining: 300,
      selectedPrimaryPhoto: '',

      summernoteConfig: {
        height: 300,
        focus: true,
        toolbar: [
          ['style', ['bold', 'italic', 'underline', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['height', ['height']]
        ]
      },

      isSubmitted: false,

      notice: new NoticeFactory(),

      init: function () {
        this.model = MembershipService.getModel();

        $scope.$on('MembershipService::Update', this.onMembershipServiceUpdate);
        $scope.$on('MembershipCategoriesCreate::Update', this.onMembershipCategoryCreateUpdate);
        $scope.$on('MembershipCategoriesCreate::Save', this.onMembershipCategoryCreateSave);

      },

      getError: function(fieldName) {
        return ValidateService.getError(fieldName);
      },

      checkForWhiteSpaces: function () {
        this.model.shortDescription = this.model.shortDescription.replace(/[\s\n]/g, ' ');
      },

      save: function () {

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        MembershipService.setModel(this.model);

        self.isSubmitted = true;
      },

      success: {
        init: function (response) {
        },

        update: function (response) {
        }
      },

      error: {
        init: function (response) {
        },
        update: function (response) {
        }

      },

      onMembershipServiceUpdate: function (e, data) {
        //the parent model has changed
        var self = $scope.membershipCategoriesCreateEmail;
        self.model = MembershipService.getModel();
      },

      onMembershipCategoryCreateUpdate: function (e, data) {
        // a tab has changed
        var self = $scope.membershipCategoriesCreateEmail;

        if (data.view === 'description') {
          self.onMembershipServiceUpdate();
        }
      },

      onMembershipCategoryCreateSave: function (e, data) {
        $scope.membershipCategoriesCreateEmail.save();
      }

    };

    $scope.membershipCategoriesCreateEmail.init();

}]);